"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTeamItemDto = instanceOfTeamItemDto;
exports.TeamItemDtoFromJSON = TeamItemDtoFromJSON;
exports.TeamItemDtoFromJSONTyped = TeamItemDtoFromJSONTyped;
exports.TeamItemDtoToJSON = TeamItemDtoToJSON;
exports.TeamItemDtoToJSONTyped = TeamItemDtoToJSONTyped;
/**
 * Check if a given object implements the TeamItemDto interface.
 */
function instanceOfTeamItemDto(value) {
    if (!('teamId' in value) || value['teamId'] === undefined)
        return false;
    if (!('teamCode' in value) || value['teamCode'] === undefined)
        return false;
    if (!('teamName' in value) || value['teamName'] === undefined)
        return false;
    if (!('isEnabled' in value) || value['isEnabled'] === undefined)
        return false;
    return true;
}
function TeamItemDtoFromJSON(json) {
    return TeamItemDtoFromJSONTyped(json, false);
}
function TeamItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'teamId': json['teamId'],
        'teamCode': json['teamCode'],
        'teamName': json['teamName'],
        'isEnabled': json['isEnabled'],
    };
}
function TeamItemDtoToJSON(json) {
    return TeamItemDtoToJSONTyped(json, false);
}
function TeamItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'teamId': value['teamId'],
        'teamCode': value['teamCode'],
        'teamName': value['teamName'],
        'isEnabled': value['isEnabled'],
    };
}
